import { TFunction } from 'i18next'

enum ContactPageType {
  All = 'All',
  Customers = 'Customers',
  Suppliers = 'Suppliers',
}

interface GetContactPageMetaProps {
  isSupplier: boolean
  isCustomer: boolean
  t: TFunction
}

export const getContactPageProps = ({ isCustomer, isSupplier, t }: GetContactPageMetaProps) => {
  if (isCustomer) {
    return {
      pageType: ContactPageType.Customers,
      pageTitle: t('contacts.filter.clients'),
    }
  }

  if (isSupplier) {
    return {
      pageType: ContactPageType.Suppliers,
      pageTitle: t('contacts.filter.vendors'),
    }
  }

  return {
    pageType: ContactPageType.All,
    pageTitle: t('contacts.header'),
  }
}
